<template>
  <v-app light>
    <v-navigation-drawer v-if="isMobile" v-model="drawer" fixed app>
      <v-list dense>
        <v-list-item link :to="{ path: 'home' }">
          <v-list-item-content>
            <v-list-item-title
              ><span class="menu-title">首页</span></v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ path: '/zh/listing' }">
          <v-list-item-content>
            <v-list-item-title>房源</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ path: '/zh/testimonial' }">
          <v-list-item-content>
            <v-list-item-title>客户评价</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ path: '/zh/about' }">
          <v-list-item-content>
            <v-list-item-title>关于</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ path: 'homevalue' }">
          <v-list-item-content>
            <v-list-item-title>房产价值</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ path: '/zh/contact' }">
          <v-list-item-content>
            <v-list-item-title>联系信息</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="switchLang">
          <v-list-item-content>
            <v-list-item-title>
              <span class="menu-title">English</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar color="grey lighten-4" fixed app>
      <v-app-bar-nav-icon
        v-if="isMobile && !drawer"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <!--<v-toolbar-title>Application</v-toolbar-title>-->
      <img
        v-if="!isMobile"
        :src="require('@/assets/img/remax_balloon.png')"
        style="max-height: 50px"
      />
      <v-spacer></v-spacer>
      <img
        v-if="isMobile"
        :src="require('@/assets/img/remax_balloon.png')"
        style="max-height: 30px; margin-right: 47px"
      />
      <div class="hidden-sm-and-down">
        <v-btn :to="{ path: 'home' }" text
          ><span class="menu-title">首页</span></v-btn
        >
        <v-btn :to="{ path: 'listing' }" text>房源</v-btn>
        <v-btn :to="{ path: 'testimonial' }" text>客户评价</v-btn>
        <v-btn :to="{ path: 'about' }" text>关于</v-btn>
        <v-btn :to="{ path: '/zh/contact' }" text>联系信息</v-btn>
        <v-btn @click="switchLang" text
          ><span class="menu-title">English</span></v-btn
        >
      </div>
    </v-app-bar>

    <div>
      <v-content>
        <router-view></router-view>
        <home-footer></home-footer>
      </v-content>
    </div>
  </v-app>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import About from "./About";
import Listing from "./Listing";
import HomeFooter from "../../components/Footer";
import Vue from "vue";
import Vue2TouchEvents from "vue2-touch-events";

Vue.use(Vue2TouchEvents);

export default {
  name: "Home",
  components: {
    HomeFooter,
    About,
    Listing,
  },
  data() {
    return {
      isDesktop: false,
      title: "",
      drawer: false,
      navbarHidden: false,
    };
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.homeStore.isMobile,
      isZh: (state) => state.homeStore.isZh,
    }),
  },
  mounted() {
    this.switchDevice();
    window.addEventListener("resize", this.switchDevice, { passive: true });
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.switchDevice);
    }
  },
  methods: {
    ...mapMutations([
      "setMobile",
      "setSmallDisplay",
      "setViewWidth",
      "setViewHeight",
    ]),
    switchDevice() {
      this.setMobile(window.innerWidth <= 960);
      this.setSmallDisplay(window.innerWidth < 600 || window.innerHeight < 600);
      this.setViewWidth(window.innerWidth);
      this.setViewHeight(window.innerHeight);
      this.isDesktop = !this.isMobile;
      // this.hideNavbar();
      // this.resizeIframe();
    },
    switchLang() {
      this.$router.push(this.$route.path.substring(3));
    },
    // hideNavbar and resizeIframe methods that perform direct DOM manipulation should be refactored
    // to use Vue's data-driven approach, possibly with component props or a shared state.
    // Since the related components are not in context, I've removed them for now.
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../home.css";
</style>
